import { useMemo, useRef } from 'react';
import { PhotoGalleryContext, useKaiProApiState } from '../contexts';
import { FileCacheInterface, FileSystemInterface } from '../FileSystem';
import { type RealtimeClient } from '../realtime';
import { createFileSystemPhotoGallery } from './createFileSystemPhotoGallery';

import { useAuth } from '../useAuth';

/**
 * FileSystem will be REQUIRED in the future
 */
export const FileSystemPhotoGalleryProvider = (
  { children, FileSystem, fileCache, realtimeClient }: {
    children: React.ReactNode;
    FileSystem: FileSystemInterface;
    fileCache: FileCacheInterface;
    realtimeClient?: RealtimeClient;
  },
) => {
  const { apiUrl } = useKaiProApiState();
  const { token } = useAuth();

  // Keep token in a ref so the gallery always reads the latest value without being recreated
  const tokenRef = useRef(token);
  tokenRef.current = token;
  const apiUrlRef = useRef(apiUrl);
  apiUrlRef.current = apiUrl;

  const gallery = useMemo(() =>
    createFileSystemPhotoGallery({
      FileSystem,
      fileCache,
      getConnectionInfo: () => ({ apiUrl: apiUrlRef.current ?? '', token: tokenRef.current }),
      realtimeClient,
    }), [FileSystem, fileCache, realtimeClient]);

  return (
    <PhotoGalleryContext.Provider value={gallery}>
      {children}
    </PhotoGalleryContext.Provider>
  );
};
